import React from "react";
import { Layout } from "antd";

import UserMenu from "../UserMenu/UserMenu";
import "./HeaderMenu.css";
import { useMatches } from "react-router";

const { Header } = Layout;

function HeaderMenu() {
  const matches = useMatches();
  const handle = matches?.find((x) => !!x.handle)?.handle as
    | { title: string }
    | undefined;
  const title = handle?.title || "";

  return (
    <Header
      style={{
        background: "#fff",
        padding: 0,
        display: "flex",
        alignItems: "center",
        zIndex: 1,
        boxShadow: "0 3px 6px lightgrey",
        clipPath: "inset(0px 0px -6px 0px)",
        justifyContent: "space-between",
      }}
    >
      <div className="header-menu-left">
        <h1
          style={{
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 22,
          }}
        >
          {title}
        </h1>
      </div>
      <div className="header-menu-right">
        <UserMenu />
      </div>
    </Header>
  );
}

export default HeaderMenu;
